import React from 'react';

export type ExpandIconProps = {
  fillColor?: string;
};

const ExpandIcon: React.FC<ExpandIconProps> = ({
  fillColor,
}: ExpandIconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 7.98658H7.98658V14H6.01342V7.98658H0V6.01342H6.01342V0H7.98658V6.01342H14V7.98658Z"
        className="summary-panel-order-icon-color"
        fill={fillColor}
      />
    </svg>
  );
};

export default ExpandIcon;
